// api.ts
export const API_BASE_URL = 'https://chessapp-backend-d5c5dye2gfhterd5.southeastasia-01.azurewebsites.net';
